import axios from 'axios'
import { Place } from '../../interfaces'

export const updatePlace = (place: Place) => {
  return axios.put('/data/sadarbības_partnera_vieta/' + place.id, place)
}
